/** Hasar parçası işlem seçimi — onarım + boya birlikte. */

export const ONARIM_SEVIYELERI = [
    { value: "HAFIF", label: "Hafif" },
    { value: "ORTA", label: "Orta" },
    { value: "YUKSEK", label: "Yüksek" },
];

export const BOYA_TIPLERI = [
    { value: "TAM", label: "Tam Boya" },
    { value: "LOCAL", label: "Lokal Boya" },
];

export function blankParcaIslem() {
    return {
        islem_degisim: false,
        islem_onarim: true,
        islem_boya: false,
        onarim_seviyesi: "ORTA",
        boya_tipi: "TAM",
        adet: 1,
    };
}

export function flagsFromApiPart(p) {
    const tip = String(p?.islem_tipi || "").toUpperCase();
    return {
        islem_degisim: tip === "DEGISIM",
        islem_onarim: tip === "ONARIM" || tip === "KARMA" || Boolean(p?.onarim_seviyesi),
        islem_boya: tip === "BOYA" || tip === "KARMA" || Boolean(p?.boya_tipi),
        onarim_seviyesi: p?.onarim_seviyesi || "ORTA",
        boya_tipi: p?.boya_tipi || "TAM",
        adet: p?.adet || 1,
    };
}

export function islemEtiket(p) {
    const tip = String(p?.islem_tipi || "").toUpperCase();
    if (tip === "KARMA") return "Onarım + Boya";
    if (tip === "ONARIM" && p?.boya_tipi) return "Onarım + Boya";
    if (tip === "DEGISIM") return "Değişim";
    if (tip === "ONARIM") return "Onarım";
    if (tip === "BOYA") return "Boya";
    if (p?.islem_onarim && p?.islem_boya) return "Onarım + Boya";
    if (p?.islem_degisim) return "Değişim";
    if (p?.islem_onarim) return "Onarım";
    if (p?.islem_boya) return "Boya";
    return "—";
}

export function buildParcaPayload(draft) {
    const adet = Number(draft.adet) || 1;
    if (draft.islem_degisim) {
        return {
            islem_tipi: "DEGISIM",
            adet,
            onarim_seviyesi: null,
            boya_tipi: null,
            islem_degisim: true,
            islem_onarim: false,
            islem_boya: false,
        };
    }
    const onarim = Boolean(draft.islem_onarim);
    const boya = Boolean(draft.islem_boya);
    if (onarim && boya) {
        return {
            islem_tipi: "KARMA",
            adet,
            onarim_seviyesi: draft.onarim_seviyesi || "ORTA",
            boya_tipi: draft.boya_tipi || "TAM",
            islem_degisim: false,
            islem_onarim: true,
            islem_boya: true,
        };
    }
    if (onarim) {
        return {
            islem_tipi: "ONARIM",
            adet,
            onarim_seviyesi: draft.onarim_seviyesi || "ORTA",
            boya_tipi: null,
            islem_degisim: false,
            islem_onarim: true,
            islem_boya: false,
        };
    }
    if (boya) {
        return {
            islem_tipi: "BOYA",
            adet,
            onarim_seviyesi: null,
            boya_tipi: draft.boya_tipi || "TAM",
            islem_degisim: false,
            islem_onarim: false,
            islem_boya: true,
        };
    }
    return null;
}

export function partSubtitleFromPart(p) {
    const bits = [islemEtiket(p), `Adet ${p.adet || 1}`];
    if (
        p.onarim_seviyesi &&
        (p.islem_onarim ||
            String(p.islem_tipi || "").includes("ONARIM") ||
            p.islem_tipi === "KARMA")
    ) {
        bits.push(
            ONARIM_SEVIYELERI.find((o) => o.value === p.onarim_seviyesi)?.label ||
                p.onarim_seviyesi,
        );
    }
    if (
        p.boya_tipi &&
        (p.islem_boya ||
            String(p.islem_tipi || "").includes("BOYA") ||
            p.islem_tipi === "KARMA")
    ) {
        bits.push(
            BOYA_TIPLERI.find((o) => o.value === p.boya_tipi)?.label || p.boya_tipi,
        );
    }
    return bits.join(" · ");
}
